// Copyright 2025, University of Maryland, All Rights Reserved
import * as LucideIcons from 'lucide-react'
import React from 'react'

/**
 * Get a Lucide icon component by name
 * @param icon_name - The name of the Lucide icon
 * @returns The icon component or undefined if not found
 */
export function getIconComponent(icon_name?: string): React.ComponentType<any> | undefined {
  if (!icon_name) return undefined
  return (LucideIcons as any)[icon_name]
}

/**
 * Get list of common Lucide icon names for UI selection
 * @returns Array of common icon names
 */
export function getCommonIconNames(): string[] {
  const common_icons = [
    'Building2', 'School', 'Users', 'Globe', 'Target', 'TrendingUp', 'TrendingDown',
    'BarChart', 'PieChart', 'Activity', 'Briefcase', 'Home', 'Settings', 'Info',
    'AlertCircle', 'CheckCircle', 'XCircle', 'Heart', 'Star', 'Flag', 'Shield',
    'Zap', 'Clock', 'Calendar', 'Map', 'Navigation', 'Compass', 'Camera', 'FileText',
    'Book', 'Bookmark', 'Archive', 'Folder', 'FolderOpen', 'File', 'Files',
    'Database', 'Server', 'Cloud', 'Wifi', 'Download', 'Upload', 'Link',
    'Mail', 'Phone', 'MessageCircle', 'Bell', 'User', 'Users2', 'UserPlus',
    'Search', 'Filter', 'Sort', 'Grid', 'List', 'Layout', 'Maximize',
    'Plus', 'Minus', 'Edit', 'Trash2', 'Save', 'Copy', 'Move', 'MoreHorizontal'
  ]
  return common_icons.sort()
}

/**
 * Check if an icon name is valid (exists in Lucide icons)
 * @param icon_name - The icon name to check
 * @returns True if the icon exists
 */
export function isValidIconName(icon_name: string): boolean {
  return !!(LucideIcons as any)[icon_name]
}
